import React, { useLayoutEffect, useRef } from "react";

function Labels() {
  const sectionRef = useRef(null);

  useLayoutEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const topMarquee = section.querySelector(".top-marquee");
    const bottomMarquee = section.querySelector(".bottom-marquee");

    const handleScroll = () => {
      const rect = section.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      const isVisible = rect.top < windowHeight && rect.bottom > 0;
      
      if (isVisible) {
        const scrollDistance = windowHeight + rect.height;
        const currentProgress = (windowHeight - rect.top) / scrollDistance;
        const progress = Math.max(0, Math.min(1, currentProgress));

        if (topMarquee) {
          // Moves text left to right
          const moveAmount = (progress * 20) - 10;
          topMarquee.style.transform = `translate3d(${moveAmount}%, 0, 0)`;
        }

        if (bottomMarquee) {
          // Moves text right to left
          const moveAmount = (progress * -20) + 10;
          bottomMarquee.style.transform = `translate3d(${moveAmount}%, 0, 0)`;
        }
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const services = [
    "Brochure Design",
    "Cotton Print",
    "Labels & Rolls",
    "Custom Design",
    "Packaging",
    "Brand Identity",
    "Digital Printing",
  ];

  return (
    <section 
      ref={sectionRef}
      style={{ backgroundColor: "#f9e9f1" }} 
      className="relative py-20 md:py-32 overflow-hidden"
    >
      {/* Container with 3D Perspective */}
      <div 
        className="relative z-10 space-y-4 md:space-y-10"
        style={{ 
          perspective: "1000px", // Enables 3D space
        }}
      >
        {/* Row 1: Rotating along X-axis */}
        <div 
          className="flex overflow-hidden py-4 md:py-8 shadow-lg"
          style={{ 
            backgroundColor: "#6cc5bf",
            transform: "rotateX(15deg) rotateZ(-1deg)", // The X rotation
            transformStyle: "preserve-3d"
          }}
        >
          <div className="top-marquee flex whitespace-nowrap will-change-transform">
            {[...services, ...services].map((service, i) => (
              <div key={`top-${i}`} className="flex items-center">
                <span className="text-2xl md:text-7xl font-black uppercase tracking-tighter text-[#f9e9f1] px-4 md:px-10">
                  {service}
                </span>
                <span className="text-[#f9e9f1]/40 text-xl md:text-4xl">✦</span>
              </div>
            ))}
          </div>
        </div>

        {/* Row 2: Reverse Rotation */}
        <div 
          className="flex overflow-hidden py-2"
          style={{ 
            transform: "rotateX(-15deg) rotateZ(1deg)", // Counter X rotation
            transformStyle: "preserve-3d"
          }}
        >
          <div className="bottom-marquee flex whitespace-nowrap will-change-transform">
            {[...services, ...services].map((service, i) => (
              <div key={`bottom-${i}`} className="flex items-center">
                <span 
                  className="text-3xl md:text-8xl font-black uppercase tracking-tighter px-6 md:px-12"
                  style={{ 
                    WebkitTextStroke: '1px #6cc5bf', 
                    color: 'transparent',
                    opacity: 0.7
                  }}
                >
                  {service}
                </span>
                <div 
                  className="w-2 h-2 md:w-4 md:h-4 rounded-full"
                  style={{ backgroundColor: "#6cc5bf" }}
                />
              </div>
            ))}
          </div>
        </div>

      </div>

      {/* Subtle bottom gradient for depth */}
      <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-[#6cc5bf]/10 to-transparent pointer-events-none" />
    </section>
  );
}

export default Labels;